/**
 * @file: LeadListEndHint.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The "end of list" hint, with hairlines flanking the label (matches the
 * refined list design). Shown once every lead has loaded.
 */

import { Typography } from '@euler/app/components/typography';
import { LD } from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';

export const LeadListEndHint = memo(({ text }: { text: string }) => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: rpx(18),
        paddingHorizontal: rpx(36),
      }}
    >
      <View style={{ flex: 1, height: 1, backgroundColor: LD.hairline }} />
      <Typography.Text
        size={rpx(12)}
        color={LD.mist}
        style={{ marginHorizontal: rpx(16) }}
      >
        {text}
      </Typography.Text>
      <View style={{ flex: 1, height: 1, backgroundColor: LD.hairline }} />
    </View>
  );
});
